export async function sendMessageToBackend({
  message,
  sessionId,
  userAuth,
  backendUrl,
  language,
  t,
}) {
  try {
    const payload = {
      message: message,
      userAuth: userAuth,
      language,
    };

    if (sessionId) {
      payload.sessionId = sessionId;
    } else {
      console.warn("No sessionId provided to backend");
    }

    console.log("Sending payload:", payload);

    const res = await fetch(`${backendUrl}/api/chat/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    console.log("Received data:", data);

    return {
      reply: data.reply || t("Sorry, I didn't get a response."),
      sessionId: data.sessionId || sessionId, // Use backend sessionId if provided, otherwise keep current
    };
  } catch (err) {
    console.error("Failed to send message:", err);
    return {
      reply: t("Sorry, something went wrong. Please try again."),
      sessionId: sessionId,
    };
  }
}
